  import React, { useState, useContext } from 'react';
  import { useNavigate } from 'react-router-dom';
  import { login } from '../../axios';
  import AuthContext from '../../AuthContext';

  import {
    Card,
    CardContent,
    Typography,
    TextField,
    Button,
    InputAdornment,
    Avatar,
  } from '@mui/material';

  import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
  import EmailIcon from '@mui/icons-material/Email';
  import LockIcon from '@mui/icons-material/Lock';
  import { motion } from 'framer-motion';

  const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const auth = useContext(AuthContext);

    const handleLogin = async (e) => {
      e.preventDefault();
      try {
        const response = await login(email, password);
        const user = response.data.user;
        //(user);
        if (user) {
          localStorage.setItem('user', JSON.stringify(user));
          auth.signin(user, () => {
            navigate('/');
          });
        }
      } catch (error) {
        //(error);
        setError('Login failed. Please check your credentials.');
      }
    };

    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '20px',
          background: 'linear-gradient(to right, #d1fae5, #a7f3d0)',
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        }}
      >
        <motion.div
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          style={{ width: '100%', maxWidth: '580px' }}
        >
          <Card
            style={{
              borderRadius: '10px',
              boxShadow: '0 25px 45px rgba(0,0,0,0.1)',
              backgroundColor: '#ffffff',
            }}
          >
            <CardContent style={{ padding: '36px' }}>
              <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                <Avatar
                  style={{
                    backgroundColor: '#16a34a',
                    width: 64,
                    height: 64,
                  }}
                >
                  <LockOutlinedIcon fontSize="large" />
                </Avatar>
              </div>

              <Typography
                variant="h5"
                component="h1"
                style={{
                  color: '#15803d',
                  fontWeight: 700,
                  textAlign: 'center',
                  marginBottom: '24px',
                }}
              >
                Welcome Back
              </Typography>

              {error && (
                <Typography
                  variant="body2"
                  color="error"
                  style={{ marginBottom: '16px', textAlign: 'center' }}
                >
                  {error}
                </Typography>
              )}

              <form
                onSubmit={handleLogin}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '20px',
                }}
              >
                <TextField
                  label="Email"
                  type="email"
                  variant="outlined"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  fullWidth
                  required
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  label="Password"
                  type="password"
                  variant="outlined"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  fullWidth
                  required
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockIcon color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  style={{
                    backgroundColor: '#16a34a',
                    fontWeight: '600',
                    padding: '12px',
                    borderRadius: '5px',
                    fontSize: '16px',
                    textTransform: 'none',
                  }}
                >
                  Login
                </Button>
              
              </form>
            </CardContent>
          </Card>
        </motion.div>
      </div>
    );
  };

  export default Login;
